// Settings constants and utilities

export const DEFAULT_MENU_COLOR = '#064E3B';
export const DEFAULT_BUTTON_COLOR = '#064E3B';

export const PRESET_COLORS = [
  { name: 'Emerald', value: '#064E3B' },
  { name: 'Navy', value: '#1e3a5f' },
  { name: 'Purple', value: '#4c1d95' },
  { name: 'Red', value: '#7f1d1d' },
  { name: 'Slate', value: '#1e293b' },
  { name: 'Black', value: '#0f0f0f' },
  { name: 'Blue', value: '#1e40af' },
  { name: 'Teal', value: '#115e59' },
];

// Optional pages that can be hidden and reordered
export const OPTIONAL_PAGES = [
  { id: 'players', label: 'Players', icon: 'Users', description: 'Manage team roster and player stats' },
  { id: 'matches', label: 'Matches', icon: 'Trophy', description: 'Track matches, lineups and results' },
  { id: 'training', label: 'Training', icon: 'Calendar', description: 'Schedule sessions and track attendance' },
  { id: 'leaderboard', label: 'Leaderboard', icon: 'Medal', description: 'View player rankings and stats' },
  { id: 'league-table', label: 'League Table', icon: 'Table', description: 'Track league standings and positions' },
  { id: 'team-kitty', label: 'Team Kitty', icon: 'PiggyBank', description: 'Track team finances' },
  { id: 'fines', label: 'Fines', icon: 'Gavel', description: 'Track player fines and payments' },
];

export const DEFAULT_PAGE_ORDER = ['players', 'matches', 'training', 'leaderboard', 'league-table', 'team-kitty', 'fines', 'coaches-office', 'tactics-board'];

// Helper to merge saved page order with any new pages
export const mergePageOrder = (savedOrder, defaultOrder) => {
  if (!savedOrder || savedOrder.length === 0) return defaultOrder;
  
  // Find pages in default that aren't in saved order
  const newPages = defaultOrder.filter(pageId => !savedOrder.includes(pageId));
  
  // Add new pages at the end
  return [...savedOrder, ...newPages];
};

// Validate image file
export const validateImageFile = (file, maxSizeMB = 5) => {
  const allowedTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/webp'];
  
  if (!allowedTypes.includes(file.type)) {
    return { valid: false, error: 'Please select a valid image file (JPEG, PNG, GIF, or WebP)' };
  }
  
  if (file.size > maxSizeMB * 1024 * 1024) {
    return { valid: false, error: `Image must be less than ${maxSizeMB}MB` };
  }
  
  return { valid: true };
};
